(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4553],{

/***/ 84553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hero032": function() { return /* binding */ Hero032; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14258);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87367);
/* harmony import */ var _Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82080);
/* harmony import */ var _Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Hero032 = function(param) {
    var payload = param.payload, position = param.position;
    var ref, ref1;
    var ref2;
    var headline = (ref2 = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var description = (ref3 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref3 !== void 0 ? ref3 : "";
    var ref4;
    var buttonText = (ref4 = payload === null || payload === void 0 ? void 0 : (ref = payload.button) === null || ref === void 0 ? void 0 : ref.buttonText) !== null && ref4 !== void 0 ? ref4 : "";
    var ref5;
    var widgetOffset = (ref5 = payload === null || payload === void 0 ? void 0 : (ref1 = payload.button) === null || ref1 === void 0 ? void 0 : ref1.widgetOffset) !== null && ref5 !== void 0 ? ref5 : 0;
    var scrollToTarget = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useOffsetScroll */ .VE)({
        widgetOffset: widgetOffset,
        position: position
    }).scrollToTarget;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().top),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Heading2 */ .XJ, {
                                className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().headline),
                                color: "dark",
                                children: headline
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Action */ .aU, {
                                onClick: scrollToTarget,
                                className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().arrow),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .JO, {
                                            className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                                            name: "arrow_right"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_2__/* .Paragraph */ .nv, {
                                        color: "brand",
                                        appearance: "bold",
                                        children: buttonText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_RichTextWidget__WEBPACK_IMPORTED_MODULE_1__/* .RichText */ .H, {
                        value: description,
                        className: (_Hero032_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description)
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Hero032);


/***/ }),

/***/ 82080:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hero032_wrapper____tBv","top":"Hero032_top__gwaGV","bottom":"Hero032_bottom__Os0E5","headline":"Hero032_headline__DjorH","description":"Hero032_description__0N1Md","play":"Hero032_play__SvVWc","icon":"Hero032_icon__7luf7","arrow":"Hero032_arrow__Ths0X"};

/***/ })

}]);